import {
    $axiosL
} from '../plugins/axios';

import axios from 'axios';

import config from '../../config.json';
import Crs from '../store/countries'

import {
    isAudio,
    isImage,
    allowFromHosts,
    removeMessage,
    redirectToResultUrl,
    handleUnload,
    shouldRedirectToResultUrl, $lang,
    generateFingerprint,
}
    from '../plugins/helper';
import Cookie from 'js-cookie';

const halfAnHour = 1 / 48;

const actions = (store) => ({
    changeStart: (state, bool) => ({
        isStart: bool
    }),
    startQuestion: (state, data) => ({
        etest: data,
        message: ''
    }),
    changeForm: (state, data) => {
        store.setState({ [data.name]: data.value })
    },
    /**
     * Set Sounds and Texts after fetching question
     *
     * @param {object} state
     * @param {array} files
     * @return {void}
     */
    setSoundAndText: async (state, files) => {
        let all = files.filter(file => file.file != '').map(file => file.file);

        let sounds = all.filter(file => isAudio(file));

        let images = all.filter(file => isImage(file));

        let texts = files.filter(file => file.text != '').map(file => file.text);

        store.setState({ sounds, texts, images })
    },

    /**
     * Load question after form/respond successfully submit
     *
     * @param {Object} state
     * @param {string} type
     * @param {FormData} formData
     * @return {void}
     */
    loadQuestion: (state, type, formData) => {
        const { email, fullname, phone_number, dial_code } = state;
        return generateFingerprint().then(fingerprint => {

            const newFormData = new FormData();
            Object.keys(formData).forEach(key => newFormData.append(key, formData[key]));
            newFormData.append("finger_print", fingerprint);

            return $axiosL.post(`${config.api_base_url}/${state.type}/question`, newFormData)
                .then(res => {
                    const { data } = res;
                    store.setState({
                        isStart: true,
                        etest: data,
                        sounds: [],
                        texts: [],
                        message: '',
                        finishTest: data.status != 'progress' ? true : false,
                        isEtest: formData['etest'],
                        is_show_result: data.is_show_result,
                        isPrepare: false,
                        attempt: data.attempt
                    });

                    if (type == 'form' || type == 'array') {
                        if (data.meta_info.timer !== 0) {
                            store.setState({ finishTest: false })
                        }

                        store.setState({
                            email: formData['email'],
                            token: formData['token'],
                            playSoundOnStart: true
                        });

                        if (allowFromHosts()) {
                            window.history.replaceState(null, 'email', `?email=${formData['email']}`);
                        }
                    }

                    let student = btoa(
                        unescape(
                            encodeURIComponent(
                                JSON.stringify(
                                    {
                                        email,
                                        fullname,
                                        phone_number,
                                        dial_code,
                                        type: state.type,
                                        is_etest: formData['etest'],
                                        is_start: true,
                                        data: res.data,
                                    }
                                )
                            )
                        )
                    )

                    if (data.status == 'progress') {
                        Cookie.set(`etest_${state.email}`, student, { expires: halfAnHour, secure: false });
                    } else {
                        Cookie.remove(`etest_${state.email}`);
                    }

                    if (shouldRedirectToResultUrl(data.status, state.type, res.data.pt_result_url)) {
                        redirectToResultUrl(res.data.pt_result_url);
                        return;
                    }

                    return res
                }).catch(err => {
                    if (err.response && err.response.status == 503) {
                        store.setState({
                            isMaintenance: true,
                            isPrepare: false
                        })
                    }

                    if (err.response && err.response.data.message) {
                        store.setState({ message: $lang('error.' + err.response.data.message) || 'Something went wrong. clue: ' + err.response.data.message });
                    }
                    if (!err.response) {
                        store.setState({
                            message: $lang('error.connection_issue')
                        })
                    }
                    return err
                })
        });
    },
    selectQuestion: (state, selected) => ({
        selected
    }),
    handleEmail: (state, email) => ({
        email
    }),
    /**
     * Set token from incoming "?token" param
     *
     * @param {object} state
     * @param {string} token
     * @return {void}
     */
    setToken: (state, token) => ({ token }),
    /**
     * Handle form change
     *
     * @param state
     * @param {Event} e
     * @return {void}
     */
    handleChange: (state, e) => {
        store.setState({ [e.target.name]: e.target.value })
    },
    /**
     * Handle dial code
     *
     * @param state
     * @param {Event} e
     * @return {void}
     */
    handleDialCode: (state, e) => {
        let country = Crs.find(
            (data) => data.country_iso === e.target.value
        );
        if (country) {
            store.setState({ dial_code: country.dial_code, country_iso: country.country_iso });
        } else {
            // set default to EN+1
            const fallback = Crs.find(
                (data) => data.country_iso === 'EN'
            );

            if (fallback) {
                store.setState({ dial_code: fallback.dial_code });
            } else {
                store.setState({ dial_code: '+1' });
            }
        }

    },
    /**
     * Save search url parameter to state and cookie
     * set etest_last cookie
     * if pre test is true
     * @param state
     * @param params
     * @return {Object}
     */
    saveParams: (state, params) => {
        store.setState({
            token: params.token,
            type: params.type,
            debug: params.debug,
            devMode: params.devMode,
            email: params.email,
            logout: params.logout,
            center_timer: params.center_timer,
            pre_test: params.pre_test,
            fullname: params.fullname,
            dial_code: params.dial_code,
            phone_number: params.phone_number,
            level: params.level
        });

        if (params.pre_test == 'true') {
            let email = params.email
            let fullname = params.fullname
            let phone_number = params.phone_number
            let dial_code = params.dial_code
            let type = params.type
            let dev_mode = params.devMode
            let token = params.token
            let pre_test = params.pre_test
            let student = btoa(
                unescape(
                    encodeURIComponent(
                        JSON.stringify(
                            {
                                email,
                                fullname,
                                phone_number,
                                dial_code,
                                type,
                                dev_mode,
                                token,
                                pre_test
                            }
                        )
                    )
                )
            )
            Cookie.set(`etest_last`, student, { expires: halfAnHour, secure: false });

        }
    },
    /**
     * Start Over Question
     *
     * @param state
     * @return void
     */
    startOver: (state) => {
        const {
            token,
            type,
            email,
        } = state;

        const data = new FormData();

        data.append('token', token);
        data.append('email', email);

        $axiosL.post(`${config.api_base_url}/${type}/reset`, data).then(res => {
            store.setState({
                isStart: false,
                wantReset: false,
                message: '',
                playSoundCount: 0,
                selectedOption: '',
                finishTest: true,
            });

            Cookie.set('is_start', false, { expires: halfAnHour, secure: false });
        }).catch(err => {
            if (!err.response) {
                store.setState({
                    message: $lang('error.connection_issue')
                })
                console.error(err)
            }
            if (err.response && err.response.status == 503) {
                store.setState({
                    isMaintenance: true,
                })
            }
            if (err.response && err.response.data.message) {
                store.setState({
                    isStart: false,
                    message: $lang('error.' + err.response.data.message) || 'Something went wrong. clue: ' + err.response.data.message,
                    wantReset: false,
                });
            }
            return Promise.reject(err);
        })
    },
    /**
     * Submit or finish the test
     *
     * @param state
     * @return void
     */
    submitQuestion: (state) => {
        const {
            token,
            type,
            email,
            level,
        } = state;
        if (!email || !token) return;
        const data = new FormData();

        data.append('token', token);
        data.append('email', email);
        if (type == 'et') {
            data.append('type', 'et');
            data.append('level', level);
        }
        if (config.app_env == 'production') {
            data.append('etest', false);
        } else {
            data.append('etest', state.devMode);
        }

        $axiosL.post(`${config.api_base_url}/${type}/submit`, data).then(res => {
            if (shouldRedirectToResultUrl(res.data.status, type, res.data.pt_result_url)) {
                redirectToResultUrl(res.data.pt_result_url);
                return;
            }

            Cookie.set('org_token', token, { expires: halfAnHour, secure: false });

            Cookie.remove(`etest_${state.email}`);

            store.setState({
                etest: res.data,
                email: '',
                message: '',
                finishTest: true,
                selectedOption: ''
            });
        }).catch(err => {
            if (!err.response) {
                store.setState({
                    message: $lang('error.connection_issue')
                })
                console.error(err)
            }
            if (err.response && err.response.status == 503) {
                store.setState({
                    isMaintenance: true,
                })
            }

            if (err.response && err.response.data.message) {
                store.setState({ message: $lang('error.' + err.response.data.message) || 'Something went wrong, could not submit data' });
            }
            return Promise.reject(err);
        })
    },
    /**
     * Add Error
     *
     * @param state
     * @param message
     * @return void
     */
    errorAdd: (state, message) => {
        store.setState({ message })
    },
    /**
     * Handle Start Over modal
     *
     * @param {Boolean} bool
     * @return void
     */
    handleModal: (state, bool) => {
        if (state.etest.attempt >= state.attempt_of_test) {
            store.setState({ message: $lang('error.start_over_retry') })
            return;
        }
        store.setState({ wantReset: bool })
    },
    /**
     * Add Play sound count
     */
    addPlaySoundCount: (state) => {
        store.setState({ playSoundCount: state.playSoundCount + 1 })
    },
    /**
     * Reset playsound count state
     *
     * @param state
     * @return void
     */
    resetPlaySoundCount: (state) => {
        store.setState({ playSoundCount: 0 })
    },
    /**
     * Get sounds from file
     *
     * @param state
     * @return void
     */
    getSound: async (state, sounds) => ({ sounds }),
    /**
     * Get Texts from question files
     *
     * @param state
     * @return {void}
     */
    getText: async (state, texts) => ({ texts }),

    /**
     * This for play sound when user start the test
     *
     * @param state
     * @param bool
     * @return void
     */
    setPlaySoundOnStart: (state, bool) => {
        store.setState({ playSoundOnStart: bool })
    },
    /**
     * Set times up
     *
     * @param state
     * @param bool
     * @return void
     */
    setFinishTest: (state, bool) => {
        store.setState({ finishTest: bool })
    },
    /**
     * Handle play button
     *
     * @param state
     * @param bool
     * @return void
     */
    handlePlayButton: (state, bool) => {
        store.setState({ isPlaying: bool });
    },

    /**
     * handle set pre test
     * @param {*} state
     * @param {*} string
     */
    handleSetPreTest: (state, string) => {
        store.setState({ pre_test: string });
    },
    /**
     * handle set email
     * @param {*} state
     * @param {*} string
     */
    handleSetEmail: (state, string) => {
        store.setState({ email: string });
    },
    /**
     * handle set dial code
     * @param {*} state
     * @param {*} string
     */
    handleSetDialCode: (state, string) => {
        store.setState({ dial_code: string });
    },
    /**
     * handle set phone number
     * @param {*} state
     * @param {*} string
     */
    handleSetPhoneNumber: (state, string) => {
        store.setState({ phone_number: string });
    },
    /**
     * handle set fullname
     * @param {*} state
     * @param {*} string
     */
    handleSetFullname: (state, string) => {
        store.setState({ fullname: string });
    },
    /**
     * Get organization from api
     *
     * @param state
     * @return {void}
     */
    getOrganization: (state, organization) => ({ organization }),
    /**
     * Reset selected option
     *
     * @param state
     * @return void
     */
    changeSelectedOption: (state, selectedOption) => ({ selectedOption }),
    /**
     * Verify token from param
     *
     * @param state
     */
    verifyToken: async (state, payload) => {
        if (!payload.token && allowFromHosts() && state.devMode != true) {
            let token;
            if (window.localStorage) {
                token = window.localStorage.getItem('token')
            }
            payload.token = token;
        }
        return $axiosL.post(`${config.api_base_url}/token/verify`, null, {
            headers: {
                'token': payload.token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(res => {
            store.setState({
                isValidToken: true,
                organization: res.data.data,
                type: res.data.data.type == 'Assessment Test' ? 'pt' : 'et',
                token: payload.token,
                attempt_of_test: res.data.data.attempt_of_test,
                certificate_plan: res.data.data.certificate_plan,
                is_auto_neojr_plus_to_neo_prep_plus: res.data.data.is_auto_neojr_plus_to_neo_prep_plus
            });

            Cookie.set('org_logo', res.data.data.logo, { expires: halfAnHour, secure: false });

            if (state.type == 'et') {
                if (res.data.data.type == 'Certification Test') {
                    store.setState({
                        levels: res.data.data.levels,
                    });
                } else {
                    store.setState({
                        message: 'This token is not Certification Test token'
                    })
                }
            }

            if (res.data.data.type == 'Certification Test') {
                store.setState({
                    type: 'et'
                })
            }

            if (allowFromHosts()) {
                if (window.localStorage) {
                    window.localStorage.setItem('token', payload.token);
                    window.history.replaceState(null, 'verified', '/');
                }
            }

            return res.data
        }).catch(err => {
            if (payload.ignoreValidation && payload.ignoreValidation == true) {
                store.setState({ message: 'Invalid Token' })
            } else {
                store.setState({ isValidToken: false })
            }
            if (err.response) {
                if (err.response.status == 503) {
                    store.setState({
                        isMaintenance: true,
                        message: $lang('error.' + err.response.data.message) || 'Something went wrong, could not verify the token',
                    });
                } else if (err.response.status == 403) {
                    store.setState({
                        isValidToken: false,
                        message: $lang('error.' + err.response.data.message_type) || err.response.data.message,
                    });
                }
            } else {
                store.setState({
                    message: $lang('error.connection_issue')
                })
            }
            return Promise.reject(err);
        })
    },
    /**
     * Handle Prepare for test to show modal
     * use the pre_test to ept cloud
     *
     * @param state
     * @param {boolean} isPrepare
     */
    handlePrepare: (state, isPrepare) => {
        const emailConfirmed = !allowFromHosts() ? true : (state.email == state.email_confirmation);
        removeMessage()
        if (state.type == 'pt' && isPrepare) {
            if (state.phone_number && state.email && state.fullname && emailConfirmed || state.pre_test == 'true') {
                new Promise((resolve, reject) => {
                    const newFormData = new FormData()
                    newFormData.append("email", state.email)
                    newFormData.append("token", state.token)
                    newFormData.append("pre_test", state.pre_test)

                    $axiosL.post(`${config.api_base_url}/${state.type}/test/validate`, newFormData)
                        .then(res => {
                            store.setState({ isPrepare })
                        }).catch(err => {
                            const email_submitted = err.response.data.message == "student_already_taken"
                            store.setState({
                                message: !email_submitted ? ($lang('error.' + err.response.data.message) || 'Something went wrong. clue: ' + err.response.data.message) : '',
                                isPrepare: email_submitted,
                                taken_test: email_submitted,
                            });
                        })
                })
            } else {
                store.setState({ message: $lang('error.invalid_credentials') });
            }
        } else {
            store.setState({ isPrepare });
        }
    },
    /**
     * Add or remove event listener beforeunload
     *
     * @param {any} state
     * @param {boolean} bool
     * @return {void}
     */
    addLeaveEvent: (state, bool) => {
        window[bool ? 'addEventListener' : 'removeEventListener']('beforeunload', handleUnload)
    },
    /**
     * Start question if etest data, org_token and email cookie is exists
     *
     * @param state
     * @return {any}
     */
    getLastQuestion(state) {
        let student = JSON.parse(
            decodeURIComponent(
                escape(atob(Cookie.get(`etest_${state.email}`)))
            )
        );

        if (student && student.is_start) {
            let token = Cookie.get('org_token');

            const { email, type, fullname, dial_code, phone_number } = student;

            store.setState({ email, token, type });

            const formData = new FormData()
            formData.append('token', token);
            formData.append('email', email);

            if (type == 'et') {
                formData.append('etest', student.is_etest);
            }
            if (student.data != null) {
                $axiosL.post(`${config.api_base_url}/${type}/timer`, formData).then(res => {
                    student.data.meta_info.timer = res.data.timer;
                    student.data.status = res.data.status;
                    store.setState({
                        email,
                        dial_code,
                        fullname,
                        phone_number,
                        isStart: student.is_start,
                        etest: student.data,
                        message: '',
                        finishTest: res.data.status != 'progress' ? true : false,
                        isEtest: student.is_etest || false,
                        is_show_result: student.data.is_show_result,
                        isPrepare: false,
                    });

                    if (student.data.status == 'progress') {
                        let all = student.data.question.files.filter(file => file.file != '').map(file => file.file);

                        let sounds = all.filter(file => isAudio(file));

                        let images = all.filter(file => isImage(file));

                        let texts = student.data.question.files.filter(file => file.text != '').map(file => file.text);

                        store.setState({ sounds, texts, images })
                    }

                    if (shouldRedirectToResultUrl(student.data.status, type, student.data.pt_result_url)) {
                        redirectToResultUrl(data.pt_result_url);
                        return;
                    }
                })
            }
        }
    },
    /**
     * Logout current student by deleting student email
     */
    logout(state) {
        if (state.logout == 'true') {
            Cookie.remove('student_email');
            location.href = '/';
        }
    },

    setLang: (state, lang) => {
        store.setState({ lang })
    },

    /**
     * Get IP Information
     * @TODO: remove later after get the geo ip by self service
     * @return void
     */

    getIP: async (state, index = 0) => {
        document.querySelector('.spinner-box').classList.add('show');
        return axios.get(`${config.geoip[index].url}`, {}, {
            auth: {
                username: `${config.geoip[index].username}`,
                password: `${config.geoip[index].password}`
            }
        })
            .then(response => {
                try {
                    // geoip format
                    const geoip = JSON.parse(response.data).country.iso_code
                    store.setState({ geoip })
                    document.querySelector('.spinner-box').classList.remove('show');

                    return response;
                } catch (e) {
                    // cloudflare formate
                    const [, geoip] = response.data
                        .split('\n')
                        .map((info) => info.split('='))
                        .find(([key]) => key === 'loc');
                    store.setState({ geoip })
                    document.querySelector('.spinner-box').classList.remove('show');

                    return response;
                }
            }).catch(err => {
                document.querySelector('.spinner-box').classList.remove('show');
            });
    }
})

export default actions
